import { SPACE_KEY } from '../../../constants/key'
import { MAIN_MOUSE_BUTTON } from '../../../constants/mouse'

export const PRESS_ACTION_TIMEOUT = 250

export const PRESS_ACTION_MOUSE_BUTTONS = new Set([MAIN_MOUSE_BUTTON])

export const PRESS_ACTION_KEY_CODES = new Set([SPACE_KEY])
